import React from 'react';

export const TwitterIcon: React.FC = (props) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 26 22" fill="none" {...props}>
      <path 
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.5 18.7c10 6.2 22.7-.7 22.5-13 1-.7 1.9-1.6 2.6-2.7-1 .5-2 .8-3.1.9 1.14-.7 2-1.7 2.4-2.9-1 .6-2 1-3.3 1.3-4.3-4.13-10 .3-8.8 4.7-4.3-.2-8-2.3-10.6-5.4C1 4 1.5 7.1 3.9 8.5 3 8.4 2 8.2 1.5 7.8c0 2.6 1.8 4.6 4.1 5.1-.8.2-1.5.3-2.3.1.6 2 2.6 3.6 4.8 3.6-2 1.6-4.7 2.4-7.6 2.1z"
        fill="#FFF" 
      />
    </svg>
  );
};

